export const SEARCH_TAG = "app/FEEDACTION/SEARCH_TAG";
export const SEARCH_TAG_SUCCESS = "app/FEEDACTION/SEARCH_TAG_SUCCESS";
export const SEARCH_TAG_FAILURE = "app/FEEDACTION/SEARCH_TAG_FAILURE";

export const UPDATE_FEED_TAGS = "app/FEEDACTION/UPDATE_FEED_TAGS";
export const RESET_FEED_TAGS = "app/FEEDACTION/RESET_FEED_TAGS";

export const DELETE_TAG = "app/FEEDACTION/DELETE_TAG";
export const DELETE_TAG_SUCCESS = "app/FEEDACTION/DELETE_TAG_SUCCESS";
export const DELETE_TAG_FAILURE = "app/FEEDACTION/DELETE_TAG_FAILURE";

export const ADD_REACTION = "app/FEEDACTION/ADD_REACTION";
export const ADD_REACTION_SUCCESS = "app/FEEDACTION/ADD_REACTION_SUCCESS";
export const ADD_REACTION_FAILURE = "app/FEEDACTION/ADD_REACTION_FAILURE";

export const FETCH_REACTIONS = "app/FEEDACTION/FETCH_REACTIONS";
export const FETCH_REACTIONS_SUCCESS = "app/FEEDACTION/FETCH_REACTIONS_SUCCESS";
export const FETCH_REACTIONS_FAILURE = "app/FEEDACTION/FETCH_REACTIONS_FAILURE";

export const FETCH_SEEN_USERS = "app/FEEDACTION/FETCH_SEEN_USERS";
export const FETCH_SEEN_USERS_SUCCESS =
  "app/FEEDACTION/FETCH_SEEN_USERS_SUCCESS";
export const FETCH_SEEN_USERS_FAILURE =
  "app/FEEDACTION/FETCH_SEEN_USERS_FAILURE";

export const FETCH_EVENT_RSVP_LIST = "app/FEEDACTION/FETCH_EVENT_RSVP_LIST";
export const FETCH_EVENT_RSVP_LIST_SUCCESS =
  "app/FEEDACTION/FETCH_EVENT_RSVP_LIST_SUCCESS";
export const FETCH_EVENT_RSVP_LIST_FAILURE =
  "app/FEEDACTION/FETCH_EVENT_RSVP_LIST_FAILURE";

export const TOGGLE_REACTION_MODAL = "app/FEEDACTION/TOGGLE_REACTION_MODAL";
export const TOGGLE_REPORT_MODAL = "app/FEEDACTION/TOGGLE_REPORT_MODAL";
export const TOGGLE_OPTION_MODAL = "app/FEEDACTION/TOGGLE_OPTION_MODAL";

export const ACKNOWLEDGE_FEED = "app/FEEDACTION/ACKNOWLEDGE_FEED";
export const ACKNOWLEDGE_FEED_SUCCESS =
  "app/FEEDACTION/ACKNOWLEDGE_FEED_SUCCESS";
export const ACKNOWLEDGE_FEED_FAILURE =
  "app/FEEDACTION/ACKNOWLEDGE_FEED_FAILURE";

export const RECORD_FEED_VIEW = "app/FEEDACTION/RECORD_FEED_VIEW";
export const RECORD_FEED_VIEW_SUCCESS =
  "app/FEEDACTION/RECORD_FEED_VIEW_SUCCESS";
export const RECORD_FEED_VIEW_FAILURE =
  "app/FEEDACTION/RECORD_FEED_VIEW_FAILURE";

export const FETCH_STATS = "app/FEEDACTION/FETCH_STATS";
export const FETCH_STATS_SUCCESS = "app/FEEDACTION/FETCH_STATS_SUCCESS";
export const FETCH_STATS_FAILURE = "app/FEEDACTION/FETCH_STATS_FAILURE";

export const FETCH_ENGAGE_REPORT = "app/FEEDACTION/FETCH_ENGAGE_REPORT";
export const FETCH_ENGAGE_REPORT_SUCCESS =
  "app/FEEDACTION/FETCH_ENGAGE_REPORT_SUCCESS";
export const FETCH_ENGAGE_REPORT_FAILURE =
  "app/FEEDACTION/FETCH_ENGAGE_REPORT_FAILURE";

export const ENGAGE_REPORT_FILTERS = "app/FEEDACTION/ENGAGE_REPORT_FILTERS";

export const KUDOS_LEADERBOARD_FILTERS =
  "app/FEEDACTION/KUDOS_LEADERBOARD_FILTERS";

export const GET_KUDOS_LEADERBOARD = "app/FEEDACTION/GET_KUDOS_LEADERBOARD";
export const GET_KUDOS_LEADERBOARD_SUCCESS =
  "app/FEEDACTION/GET_KUDOS_LEADERBOARD_SUCCESS";
export const GET_KUDOS_LEADERBOARD_FAILURE =
  "app/FEEDACTION/GET_KUDOS_LEADERBOARD_FAILURE";

export const FETCH_KUDOS_REPORT = "app/FEEDACTION/FETCH_KUDOS_REPORT";
export const FETCH_KUDOS_REPORT_SUCCESS =
  "app/FEEDACTION/FETCH_KUDOS_REPORT_SUCCESS";
export const FETCH_KUDOS_REPORT_FAILURE =
  "app/FEEDACTION/FETCH_KUDOS_REPORT_FAILURE";
export const KUDOS_REPORT_FILTERS = "app/FEEDACTION/KUDOS_REPORT_FILTERS";

export const FETCH_VALUES_REPORT = "app/FEEDACTION/FETCH_VALUES_REPORT";
export const FETCH_VALUES_REPORT_SUCCESS =
  "app/FEEDACTION/FETCH_VALUES_REPORT_SUCCESS";
export const FETCH_VALUES_REPORT_FAILURE =
  "app/FEEDACTION/FETCH_VALUES_REPORT_FAILURE";
export const VALUES_REPORT_FILTERS = "app/FEEDACTION/VALUES_REPORT_FILTERS";
export const FETCH_COMPANY_SCORECARD_REPORT =
  "app/FEEDACTION/FETCH_COMPANY_SCORECARD_REPORT";
export const FETCH_COMPANY_SCORECARD_REPORT_SUCCESS =
  "app/FEEDACTION/FETCH_COMPANY_SCORECARD_REPORT_SUCCESS";
export const FETCH_COMPANY_SCORECARD_REPORT_FAILURE =
  "app/FEEDACTION/FETCH_COMPANY_SCORECARD_REPORT_FAILURE";

export const PIN_FEED = "app/FEEDACTION/PIN_FEED";
export const PIN_FEED_SUCCESS = "app/FEEDACTION/PIN_FEED_SUCCESS";
export const PIN_FEED_FAILURE = "app/FEEDACTION/PIN_FEED_FAILURE";

export const EXPORT_ACKNOWLEDGED_FEEDS =
  "app/FEEDACTION/EXPORT_ACKNOWLEDGED_FEEDS";
export const EXPORT_ACKNOWLEDGED_FEEDS_SUCCESS =
  "app/FEEDACTION/EXPORT_ACKNOWLEDGED_FEEDS_SUCCESS";
export const EXPORT_ACKNOWLEDGED_FEEDS_FAILURE =
  "app/FEEDACTION/EXPORT_ACKNOWLEDGED_FEEDS_FAILURE";
